(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[319],{

/***/ 4537:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workout/[slug]",
      function () {
        return __webpack_require__(923);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ WorkoutPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/layout/PageLayout.tsx + 4 modules
var PageLayout = __webpack_require__(8349);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./components/ui/Important.tsx
var Important = __webpack_require__(7986);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(6437);
;// CONCATENATED MODULE: ./components/richTextStyling.tsx




var _obj;
var renderOptions = {
    renderMark: {},
    renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_1, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: "text-2xl py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_2, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: "text-xl py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_3, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            className: "text-lg py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_4, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            className: "text-base py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_5, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
            className: "text-sm py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_6, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
            className: "text-xs py-4",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: "py-1.5",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.UL_LIST, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "",
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.QUOTE, function(_node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Important/* default */.Z, {
            elementType: "blockquote",
            children: children
        });
    }), _obj)
};
/* harmony default export */ var richTextStyling = (renderOptions);

// EXTERNAL MODULE: ./content/links.ts
var links = __webpack_require__(6830);
// EXTERNAL MODULE: ./content/text.ts
var content_text = __webpack_require__(9930);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(4129);
;// CONCATENATED MODULE: ./pages/workout/[slug].tsx






var __N_SSG = true;
function WorkoutPage(param) {
    var _post = param.post, text = _post.text, title = _post.title, slug = _post.slug;
    var og = {
        site_name: content_text/* seo.title */.$K.title,
        title: title + " - " + content_text/* seo.title */.$K.title,
        description: "Workout",
        url: links/* baseUrl */.FH + "/workout/" + slug
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        openGraph: og,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: " w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-3xl mb-8 mt-2.5 pb-8 text-center font-black text-knut-light-header dark:text-knut-dark-header",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-knut-light-header dark:text-knut-dark-header lg:prose-lg xl:prose-xl",
                    children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(text, richTextStyling)
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,553,680,252,774,888,179], function() { return __webpack_exec__(4537); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);